export const Config = {
    apiHost: '/api'
}